export default __webpack_public_path__ + "static/media/locations-calendar.8d7308f4.png";